export enum TabTitle {
    Faulted = "Faulted",
    Offline = "Offline",
    Unknown = "Unknown",
    NonOperational = "Non-Operational",
    Warnings = "Warnings",
}
